<template>
  <sub-request></sub-request>
</template>

<script>
import SubRequest from '../components/sub-requests/index';

export default { components: { SubRequest } };
</script>
